import { defineStore } from 'pinia';
import api from '@/api';
import router from '@/router';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    tienda_id: typeof window !== 'undefined' && localStorage.getItem('tienda_id') ? localStorage.getItem('tienda_id') : null,
    token: typeof window !== 'undefined' && localStorage.getItem('token') ? localStorage.getItem('token') : null,
    urlParams: {} // Agregar estado para los parámetros de URL
  }),

  getters: {
    isAuthenticated: (state) => !!state.token,
    hasUrlParams: (state) => Object.keys(state.urlParams).length > 0
  },

  actions: {
    async login(email, password, urlParams = {}) {
      try {
        // Si hay un token en los parámetros de URL, usarlo en lugar del login normal
        if (urlParams.token) {
          return await this.loginWithToken(urlParams.token, urlParams);
        }
        
        const response = await api.login(email, password);
        this.token = response.data.token;
        // el login normal no tiene tienda_id
        //this.tienda_id = response.data.tienda_id;



        this.urlParams = urlParams; // Guardar los parámetros de URL
        localStorage.setItem('token', this.token);
        // No hacer router.push aquí, dejarlo al componente
        return true;
      } catch (error) {
        this.logout();
        throw error;
      }
    },

    async loginWithToken(token, urlParams = {}) {
      try {
        const response = await api.loginWithToken(token);
        this.token = response.data.token;
        
        this.urlParams = urlParams;

        console.log(response)
        
        // IMPORTANTE: Siempre sobrescribir el token en localStorage con el nuevo
        localStorage.setItem('token', this.token);
        localStorage.setItem('tienda_id', response.data.tienda_id)

        return true;
      } catch (error) {
        this.logout();
        throw error;
      }
    },

    logout() {
      this.token = null;
      this.user = null;
      this.urlParams = {}; // Limpiar parámetros al cerrar sesión
      localStorage.removeItem('token');
      localStorage.removeItem('urlParams'); // Limpiar parámetros del localStorage
      router.push('/login');
    },

    // Método para restaurar parámetros desde localStorage si es necesario
    restoreUrlParams() {
      if (typeof window !== 'undefined') {
        const savedParams = localStorage.getItem('urlParams');
        if (savedParams) {
          try {
            this.urlParams = JSON.parse(savedParams);
          } catch (error) {
            console.error('Error parsing saved URL params:', error);
            this.urlParams = {};
          }
        }
      }
    },

    // Método para limpiar solo los parámetros sin afectar la sesión
    clearUrlParams() {
      this.urlParams = {};
      localStorage.removeItem('urlParams');
    },

    // Método para actualizar parámetros sin hacer login
    setUrlParams(params) {
      this.urlParams = params;
      if (Object.keys(params).length > 0) {
        localStorage.setItem('urlParams', JSON.stringify(params));
      } else {
        localStorage.removeItem('urlParams');
      }
    },
    
    // Nuevo método para verificar y actualizar token desde URL
    async checkAndUpdateTokenFromUrl(urlParams) {
      if (urlParams.token) {
        // Si hay un token en la URL, siempre usarlo
        console.log('Token detectado en URL, actualizando...');
        try {
          await this.loginWithToken(urlParams.token, urlParams);
          return true;
        } catch (error) {
          console.error('Error al actualizar token desde URL:', error);
          throw error;
        }
      }
      return false;
    }
  }
});